// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__Bw74I","message":"Toast_message__1iGSc","tick":"Toast_tick__2JX-Z","action":"Toast_action__2JXkT","dismiss":"Toast_dismiss__2g6Bq"};